import { KeyboardEvent } from "react";

import { SearchLgIcon, TextField, TextFieldProps } from "components";
import { gray } from "configs/colors";

const IndexComponent = ({
  label,
  placeholder,
  defaultValue,
  sx,
  onChange,
  onSearch,
  ref,
}: {
  label?: string;
  placeholder?: string;
  defaultValue?: string | null;
  sx?: TextFieldProps["sx"];
  onChange?: (v: string) => void;
  onSearch?: () => void;
  ref?: React.ComponentProps<typeof TextField>["ref"];
}) => {
  const onKeyDownHandler = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== "Enter") return;
    onSearch?.();
  };
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <SearchLgIcon
            sx={{ color: gray[500] }}
            cursor="pointer"
            fontSize="small"
            onClick={onSearch}
          />
        ),
      }}
      name="search"
      sx={sx}
      defaultValue={defaultValue}
      onChange={onChange}
      onKeyDown={onKeyDownHandler}
      ref={ref}
    />
  );
};

export default IndexComponent;
